export enum Step {
    Creation,
    Loading,
    Rephrase,
    Disambiguation,
    Error,
    Edit,
    Finish,
    ComingSoon,
    ProMigration,
}

export enum MandatorySectionTypes {
    Budget = 'budget',
    Timeline = 'timeline',
    MetadataAnswer = 'metadata_answer',
    Title = 'title',
}

export const METRICS_PREFIX = 'packages.dm_brief_creation_drawer';
export const MAX_EXTRACTION_INPUT_LENGTH = 3000;

export const BRIEF_CREATED_CLOUDINARY_GIF =
    'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/9455c3d72b56552c32b4de0fadec23aa-1727094705377/brief_created.gif';
export const FINDING_FREELANCERS_CLOUDINARY_GIF =
    'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/9455c3d72b56552c32b4de0fadec23aa-1727094705386/finding_freelancers.gif';

export const restrictedCountries = ['IN', 'BD', 'PK', 'ID', 'MA', 'NG', 'LK', 'KE'];

export const NOT_SURE_METADATA_KEY = 'not_sure';

export const GTM_EVENTS = {
    DM_GENERATE: 'DM_GENERATE',
    DM_POST: 'DM_POST',
};
